module.exports = __webpack_public_path__ + "static/media/silverTop3M.68e85005.webp";